import pages from "~/i18n/pages";
import { useT } from "~/i18n/useT";

import SectionHeading from "./SectionHeading";
import "./ProcessSteps.scss";

/** "A tailored approach to mastery". Split heading on home, centred on about. */
export default function ProcessSteps({
  variant = "split",
}: {
  variant?: "split" | "center";
}) {
  const t = useT(pages);

  return (
    <section className="ss-section ss-container">
      <SectionHeading
        eyebrow={t.process.eyebrow}
        title={t.process.title}
        aside={variant === "split" ? t.process.aside : undefined}
        variant={variant}
      />

      <ol className="ss-grid-3 ss-process">
        {t.process.steps.map((step, index) => (
          <li key={step.title} className="ss-card ss-process__card">
            <span className="ss-process__n" aria-hidden="true">
              {String(index + 1).padStart(2, "0")}
            </span>
            <h3 className="ss-process__title">{step.title}</h3>
            <p className="ss-process__body">{step.body}</p>
          </li>
        ))}
      </ol>
    </section>
  );
}
